export const audioUrlRegex =
  /^https?:\/\/[\w\-\.]+(\.[a-z]{2,})+(\/[\w\-\.~:\/\?#\[\]@!$&'\(\)\*\+,;=%]*)*\/?[\w\-\.~:\/\?#\[\]@!$&'\(\)\*\+,;=%]*\.(mp3|m3u8)$/i;
